export default __webpack_public_path__ + "static/media/footer-App-Store.78c9894e.png";